module.exports = __webpack_public_path__ + "static/media/icon-quarterlyreports-grey.3331fc93.svg";